/* Local Food Watch (sections/fw-hub.liquid). Fetches assets/food-watch-events.json once, then filters in the browser.
   Data: {generated, coverage:{cities, zips}, zips:{zip:[lat,lon]}, events:[{id, display_name, category, city, zip,
   lat, lon, event_type, first_seen_operating, announced_date, source_url, website}]}. Food trucks have no address/zip/lat.
   URL parameters: zip, radius, city, filter (just|90|soon|announced|closed|all), category. */
(function () {
  'use strict';
  var root = document.getElementById('fw');
  if (!root) return;

  var MAPLIBRE = 'https://unpkg.com/maplibre-gl@5.24.0/dist/maplibre-gl';
  var PAGE = 30, DAY = 864e5;
  var LABELS = {
    restaurant: 'Restaurants', coffee_cafe: 'Coffee & caf\u00e9s', bakery: 'Bakeries', ice_cream: 'Ice cream & frozen desserts',
    donut_cookie: 'Donuts & cookies', grocery: 'Grocery', food_hall_market: 'Food halls & markets',
    chocolate_candy: 'Chocolate & candy', bubble_tea_beverage: 'Bubble tea & drinks', specialty_food: 'Specialty food',
    farmers_market_farm_stand: 'Farmers markets & farm stands', food_truck: 'Food trucks'
  };
  var ORDER = Object.keys(LABELS);
  var SINGULAR = {
    restaurant: 'Restaurant', coffee_cafe: 'Coffee & caf\u00e9', bakery: 'Bakery', ice_cream: 'Ice cream & frozen desserts',
    donut_cookie: 'Donuts & cookies', grocery: 'Grocery', food_hall_market: 'Food hall & market',
    chocolate_candy: 'Chocolate & candy', bubble_tea_beverage: 'Bubble tea & drinks', specialty_food: 'Specialty food',
    farmers_market_farm_stand: 'Farmers market & farm stand', food_truck: 'Food truck'
  };
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October',
    'November', 'December'];
  var FILTERS = ['just', '90', 'soon', 'announced', 'closed', 'all'];

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function track(name, params) { try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* no analytics */ } }

  var form = $('[data-fw-form]'), zipIn = form.elements.zip, radiusIn = form.elements.radius;
  var list = $('[data-fw-results]'), moreBtn = $('[data-fw-more]'), empty = $('[data-fw-empty]');
  var summary = $('[data-fw-summary]'), catBar = $('[data-fw-cats]');
  var mapWrap = $('[data-fw-mapwrap]'), mapBox = $('[data-fw-map]'), mapBtn = $('[data-fw-maptoggle]');
  var tagsIn = root.querySelector('[data-fw-tags]'), followZip = root.querySelector('[data-fw-followzip]');

  var data = null, events = [], now = Date.now();
  var st = { zip: '', radius: 10, city: '', county: '', filter: '90', category: '', near: null };
  // statewide counties (Oct 25 2026): data.coverage.counties = [{key, label, cities, tracked_since}]; Maricopa countywide
  // since Oct 24 2026 (before that only Phoenix, Scottsdale and Tempe: a coverage with just those three keeps the old words)
  var PILOT = ['Phoenix', 'Scottsdale', 'Tempe'];
  var AREA = { maricopa: 'Maricopa County (Phoenix area)', pima: 'Pima County (Tucson area)', pinal: 'Pinal County',
    mohave: 'Mohave County (Kingman, Bullhead City, Lake Havasu City)' };
  var PILL = { pima: 'Tucson area', pinal: 'Pinal County', mohave: 'Mohave County' };
  var CITY_PILLS = 8;                                  // Maricopa city pills: the pilot three + the busiest others
  function counties() { return (data && data.coverage && Array.isArray(data.coverage.counties)) ? data.coverage.counties : [{ key: 'maricopa' }]; }
  function areaText() {
    var a = [];
    counties().forEach(function (c) {
      if (c.key === 'maricopa' && (c.cities || PILOT).length <= PILOT.length) a.push.apply(a, PILOT); else if (AREA[c.key] || c.label) a.push(AREA[c.key] || c.label);
    });
    return a.length < 2 ? (a[0] || AREA.maricopa) : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1];
  }
  var shown = PAGE, current = [];
  var map = null, mapLoading = null, markers = [];

  // ------------------------------------------------------------------ remembered ZIP (this browser only)
  var ZIP_KEY = 'fw_zip';
  function savedZip() { try { var z = localStorage.getItem(ZIP_KEY) || ''; return /^\d{5}$/.test(z) ? z : ''; } catch (e) { return ''; } }
  function saveZip(z) {
    try { if (/^\d{5}$/.test(z)) localStorage.setItem(ZIP_KEY, z); else localStorage.removeItem(ZIP_KEY); } catch (e) { /* storage off */ }
  }

  // ------------------------------------------------------------------ state <-> URL
  function readUrl() {
    var p = new URLSearchParams(location.search);
    var z = (p.get('zip') || '').trim();
    if (/^\d{5}$/.test(z)) st.zip = z;
    else if (!p.has('zip')) st.zip = savedZip();     // no ZIP in the link: the one this visitor used last time
    var r = parseInt(p.get('radius'), 10);
    if ([5, 10, 15, 25].indexOf(r) >= 0) st.radius = r;
    var c = p.get('city') || '';
    if (/^[A-Za-z .'-]{2,40}$/.test(c)) st.city = c;    // checked against the data's cities once it loads (cityPills)
    var co = p.get('county') || '';
    if (PILL[co]) st.county = co;
    if (FILTERS.indexOf(p.get('filter')) >= 0) st.filter = p.get('filter');
    if (LABELS[p.get('category')]) st.category = p.get('category');
  }
  function writeUrl() {
    var p = new URLSearchParams(location.search);
    function set(k, v, def) { if (v && String(v) !== String(def)) p.set(k, v); else p.delete(k); }
    set('zip', st.zip, ''); set('radius', st.radius, 10); set('city', st.city, ''); set('county', st.county, '');
    set('filter', st.filter, '90'); set('category', st.category, '');
    var q = p.toString();
    try { history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash); } catch (e) { /* ignore */ }
  }

  // ------------------------------------------------------------------ data helpers
  function day(s) { var t = s ? Date.parse(s + 'T12:00:00') : NaN; return isNaN(t) ? null : t; }
  function isTruck(e) { return e.category === 'food_truck'; }
  function opened(e) { return e.event_type === 'opened'; }
  function closed(e) { return /clos/.test(e.event_type || ''); }
  function age(e) { var t = day(e.first_seen_operating); return t == null ? Infinity : (now - t) / DAY; }
  function sortKey(e) {
    if (opened(e)) return e.first_seen_operating || '';
    return e.announced_date || e.first_seen_operating || '';
  }
  function statusOf(e, f) {
    if (f === 'all') return true;
    if (f === 'just') return opened(e) && age(e) <= 30;
    if (f === '90') return opened(e) && age(e) <= 90;
    if (f === 'soon') return e.event_type === 'coming_soon';
    if (f === 'announced') return e.event_type === 'announced';
    if (f === 'closed') return closed(e);
    return false;
  }
  function miles(a, b) {
    var R = 3958.8, r = Math.PI / 180;
    var dLat = (b[0] - a[0]) * r, dLon = (b[1] - a[1]) * r;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a[0] * r) * Math.cos(b[0] * r) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
  }
  function hasPoint(e) { return typeof e.lat === 'number' && typeof e.lon === 'number' && !isTruck(e); }

  // the city most businesses in a ZIP belong to (food trucks have no ZIP; they follow the ZIP's city)
  var zipCity = {};
  function buildZipCity() {
    var c = {};
    events.forEach(function (e) {
      if (!e.zip || !e.city) return;
      var z = String(e.zip).slice(0, 5);
      c[z] = c[z] || {};
      c[z][e.city] = (c[z][e.city] || 0) + 1;
    });
    Object.keys(c).forEach(function (z) {
      zipCity[z] = Object.keys(c[z]).sort(function (a, b) { return c[z][b] - c[z][a]; })[0];
    });
  }

  function centre() {
    if (st.near) return st.near;
    if (st.zip && data.zips && data.zips[st.zip]) return data.zips[st.zip];
    return null;
  }
  function zipCovered() { return !st.zip || st.near || !!(data.zips && data.zips[st.zip]); }

  // everything that matches place + city (before status and category)
  function placeSet() {
    var c = centre(), tc = st.near ? null : zipCity[st.zip];
    return events.filter(function (e) {
      if (st.city && e.city !== st.city) return false;
      if (st.county && (e.county || 'maricopa') !== st.county) return false;
      if (!c) return true;
      if (isTruck(e)) return !!tc && e.city === tc;
      if (!hasPoint(e)) return false;
      e._mi = miles(c, [e.lat, e.lon]);
      return e._mi <= st.radius;
    });
  }

  // ------------------------------------------------------------------ render
  function monthYear(s) { var t = day(s); if (t == null) return ''; var d = new Date(t); return MONTHS[d.getMonth()] + ' ' + d.getFullYear(); }
  function dateLine(e) {
    if (opened(e)) { var m = monthYear(e.first_seen_operating); return m ? 'Open since ' + m : 'Open'; }
    if (e.event_type === 'coming_soon') return 'Coming soon';
    if (e.event_type === 'announced') { var a = monthYear(e.announced_date); return a ? 'Announced ' + a : 'Announced'; }
    if (closed(e)) return 'Recently closed';
    return '';
  }
  function sourceLabel(u) { return /maricopa\.gov|pinal\.gov/i.test(u || '') ? 'County permit' : /pima\.gov|mohave\.gov/i.test(u || '') ? 'County listing' : 'Source'; }

  function card(e) {
    var name = e.display_name || e.business_name || 'Unnamed business';
    var place = isTruck(e) ? esc(e.city || '') + (e.city ? ' \u00b7 ' : '') + 'Food truck'
      : esc(e.city || '') + (e.zip ? ' ' + esc(String(e.zip).slice(0, 5)) : '');
    var links = [];
    if (hasPoint(e)) {
      links.push('<a href="https://www.google.com/maps/dir/?api=1&destination=' + e.lat + ',' + e.lon +
        '" target="_blank" rel="noopener">Directions</a>');
    }
    if (e.website && /^https?:\/\//i.test(e.website)) {
      links.push('<a href="' + esc(e.website) + '" target="_blank" rel="nofollow noopener">Website</a>');
    }
    if (e.source_url && /^https?:\/\//i.test(e.source_url)) {
      links.push('<a href="' + esc(e.source_url) + '" target="_blank" rel="nofollow noopener">' + sourceLabel(e.source_url) + '</a>');
    }
    var dl = dateLine(e);
    return '<li class="fm-card fw-card" data-id="' + esc(e.id) + '">' +
      '<h3>' + esc(name) + '</h3>' +
      '<p class="fw-cat">' + esc(SINGULAR[e.category] || 'Food business') + '</p>' +
      '<p>' + place + (e._mi != null && centre() && !isTruck(e) ? ' <span class="fw-mi">\u00b7 ' + e._mi.toFixed(1) + ' mi</span>' : '') + '</p>' +
      (dl ? '<p class="fw-date fw-date--' + esc(e.event_type) + '">' + esc(dl) + '</p>' : '') +
      (links.length ? '<p class="fw-links">' + links.join(' \u00b7 ') + '</p>' : '') +
      '</li>';
  }

  function setPressed(btns, attr, val) {
    btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute(attr) === val)); });
  }

  function render(opts) {
    opts = opts || {};
    events.forEach(function (e) { e._mi = null; });
    var places = placeSet();
    // status counts
    $$('[data-filter]').forEach(function (b) {
      var f = b.getAttribute('data-filter');
      var n = places.filter(function (e) { return statusOf(e, f); }).length;
      b.querySelector('.fm-c').textContent = n ? '(' + n + ')' : '';
      if (f === 'closed') b.hidden = n === 0 && st.filter !== 'closed';
    });
    setPressed($$('[data-filter]'), 'data-filter', st.filter);
    setPressed($$('[data-city]'), 'data-city', st.county ? '__county__' : st.city);
    setPressed($$('[data-county]'), 'data-county', st.county);

    var byStatus = places.filter(function (e) { return statusOf(e, st.filter); });
    // category chips: only categories present in the current results
    var counts = {};
    byStatus.forEach(function (e) { counts[e.category] = (counts[e.category] || 0) + 1; });
    var cats = ORDER.filter(function (k) { return counts[k] || k === st.category; });
    catBar.innerHTML = cats.length ? '<button type="button" class="fm-pill" data-cat="" aria-pressed="' + (!st.category) + '">All categories</button>' +
      cats.map(function (k) {
        return '<button type="button" class="fm-pill" data-cat="' + k + '" aria-pressed="' + (st.category === k) + '">' +
          esc(LABELS[k]) + ' <span class="fm-c">(' + (counts[k] || 0) + ')</span></button>';
      }).join('') : '';

    current = byStatus.filter(function (e) { return !st.category || e.category === st.category; });
    current.sort(function (a, b) {
      var ka = sortKey(a), kb = sortKey(b);
      if (ka !== kb) return ka < kb ? 1 : -1;
      return (b.id || 0) - (a.id || 0);
    });
    if (!opts.keepShown) shown = PAGE;

    // empty states
    var msg = '';
    if (st.zip && !st.near && !zipCovered()) {
      msg = "We don't cover " + esc(st.zip) + ' yet. <a href="#follow">Follow it</a> and we\'ll tell you when we do.';
      current = [];
    } else if (!current.length && (st.zip || st.near)) {
      msg = 'No new openings within ' + st.radius + ' miles of ' + (st.near ? 'your location' : esc(st.zip)) +
        ' yet. <a href="#follow">Follow your ZIP</a> and we\'ll tell you when there are.';
    } else if (!current.length) {
      msg = 'Nothing matches these filters yet. Try "All".';
    }
    empty.innerHTML = msg;
    empty.hidden = !msg;
    list.innerHTML = current.slice(0, shown).map(card).join('');
    moreBtn.hidden = current.length <= shown;

    var where = st.near ? 'near you' : st.zip ? 'within ' + st.radius + ' miles of ' + st.zip : st.city ? 'in ' + st.city : st.county ? 'in ' + (AREA[st.county] || st.county) : 'in ' + areaText();
    summary.textContent = current.length ? current.length + ' food business' + (current.length === 1 ? '' : 'es') + ' ' + where + '.' : '';
    if (map) drawMarkers();
  }

  function cityPills(bar) {
    // Maricopa city pills: the pilot three, then the cities with the most listings (countywide since Oct 24 2026)
    var mc = counties().filter(function (c) { return c.key === 'maricopa'; })[0] || {};
    var n = {};
    events.forEach(function (e) { if ((e.county || 'maricopa') === 'maricopa' && e.city) n[e.city] = (n[e.city] || 0) + 1; });
    var known = mc.cities || PILOT;
    if (st.city && known.indexOf(st.city) < 0 && !n[st.city]) st.city = '';
    var more = Object.keys(n).filter(function (c) { return PILOT.indexOf(c) < 0; })
      .sort(function (a, b) { return n[b] - n[a] || (a < b ? -1 : 1); }).slice(0, CITY_PILLS - PILOT.length);
    if (st.city && PILOT.indexOf(st.city) < 0 && more.indexOf(st.city) < 0) more.push(st.city);
    more.forEach(function (c) {
      if (!bar || bar.querySelector('[data-city="' + c.replace(/"/g, '') + '"]')) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'fm-pill'; b.setAttribute('role', 'tab');
      b.setAttribute('data-city', c); b.setAttribute('aria-pressed', 'false'); b.textContent = c;
      b.addEventListener('click', function () { st.city = c; st.county = ''; writeUrl(); render(); });
      bar.appendChild(b);
    });
  }

  function countyUi() {
    // area wording + Maricopa city pills + one pill per extra county
    $$('[data-fw-area]').forEach(function (el) { el.textContent = areaText(); });
    cityPills($('[data-fw-cities]'));
    var bar = $('[data-fw-cities]'), extra = counties().filter(function (c) { return c.key !== 'maricopa' && PILL[c.key]; });
    extra.forEach(function (c) {
      if (!bar || bar.querySelector('[data-county="' + c.key + '"]')) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'fm-pill'; b.setAttribute('role', 'tab');
      b.setAttribute('data-county', c.key); b.setAttribute('aria-pressed', 'false'); b.textContent = PILL[c.key];
      b.addEventListener('click', function () { st.county = c.key; st.city = ''; writeUrl(); render(); });
      bar.appendChild(b);
    });
    var src = $('[data-fw-src-extra]');
    if (src && extra.length) {
      src.textContent = '; plus ' + extra.map(function (c) {
        return (c.key === 'pima' ? 'Pima County Health Department facility listings'
          : c.key === 'mohave' ? 'Mohave County monthly inspection lists' : c.label + ' food permits') +
          (c.tracked_since ? ' (tracked since ' + monthYear(c.tracked_since) + ')' : '');
      }).join(' and ');
    }
  }

  function lead() {
    var n = events.filter(function (e) { return opened(e) && age(e) <= 90; }).length;
    var m = events.filter(function (e) { return e.event_type === 'coming_soon' || e.event_type === 'announced'; }).length;
    var nEl = $('[data-fw-n]'), mEl = $('[data-fw-m]');
    if (nEl) nEl.textContent = n.toLocaleString('en-US');
    if (mEl) mEl.textContent = m.toLocaleString('en-US');
  }

  function syncFollow() {
    var z = st.zip || (followZip && /^\d{5}$/.test(followZip.value) ? followZip.value : '');
    if (followZip && st.zip && !followZip.value) followZip.value = st.zip;
    if (followZip && /^\d{5}$/.test(followZip.value)) z = followZip.value;
    if (tagsIn) tagsIn.value = z ? 'food-watch, fw-zip-' + z : 'food-watch';
  }

  // ------------------------------------------------------------------ map (MapLibre, loaded on first open)
  function loadMap() {
    if (mapLoading) return mapLoading;
    mapLoading = new Promise(function (resolve, reject) {
      if (window.maplibregl) return resolve(window.maplibregl);
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = MAPLIBRE + '.css';
      document.head.appendChild(css);
      var s = document.createElement('script');
      s.src = MAPLIBRE + '.js';
      s.async = true;
      s.onload = function () { resolve(window.maplibregl); };
      s.onerror = function () { reject(new Error('map failed to load')); };
      document.head.appendChild(s);
    }).then(function (ml) {
      map = new ml.Map({ container: mapBox, style: root.dataset.mapStyle, center: [-111.95, 33.48], zoom: 9.5,
        attributionControl: { compact: true }, dragRotate: false, pitchWithRotate: false });
      map.touchZoomRotate.disableRotation();
      map.addControl(new ml.NavigationControl({ showCompass: false }), 'top-right');
      return map;
    }).catch(function () {
      var f = root.querySelector('.fw-mapfail');
      if (f) f.hidden = false;
      return null;
    });
    return mapLoading;
  }

  function scrollToCard(id) {
    var idx = -1;
    current.forEach(function (e, i) { if (String(e.id) === String(id)) idx = i; });
    if (idx < 0) return;
    if (idx >= shown) { shown = Math.ceil((idx + 1) / PAGE) * PAGE; list.innerHTML = current.slice(0, shown).map(card).join(''); moreBtn.hidden = current.length <= shown; }
    var li = list.querySelector('[data-id="' + String(id).replace(/"/g, '') + '"]');
    if (!li) return;
    li.scrollIntoView({ behavior: 'smooth', block: 'center' });
    li.classList.add('is-hit');
    setTimeout(function () { li.classList.remove('is-hit'); }, 1600);
  }

  function drawMarkers() {
    loadMap().then(function (m) {
      if (!m) return;
      var ml = window.maplibregl;
      markers.forEach(function (k) { k.remove(); });
      markers = [];
      var bounds = new ml.LngLatBounds(), n = 0;
      current.forEach(function (e) {
        if (!hasPoint(e)) return;
        var el = document.createElement('button');
        el.type = 'button';
        el.className = 'fm-pin';
        el.setAttribute('aria-label', e.display_name || '');
        var pop = new ml.Popup({ offset: 12, closeButton: false })
          .setHTML('<strong>' + esc(e.display_name) + '</strong><br>' + esc(SINGULAR[e.category] || ''));
        var mk = new ml.Marker({ element: el }).setLngLat([e.lon, e.lat]).setPopup(pop).addTo(m);
        el.addEventListener('click', function () { scrollToCard(e.id); });
        markers.push(mk);
        bounds.extend([e.lon, e.lat]);
        n++;
      });
      var c = centre();
      if (c) bounds.extend([c[1], c[0]]);
      if (n) m.fitBounds(bounds, { padding: 40, maxZoom: 14, duration: 0 });
    });
  }

  // ------------------------------------------------------------------ events
  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var z = (zipIn.value || '').replace(/\D/g, '').slice(0, 5);
    zipIn.value = z;
    st.zip = z.length === 5 ? z : '';
    st.near = null;
    st.radius = parseInt(radiusIn.value, 10) || 10;
    saveZip(st.zip);
    writeUrl();
    syncFollow();
    render();
    track('fw_search', { zip: st.zip, radius: st.radius, results: current.length });
  });
  radiusIn.addEventListener('change', function () {
    st.radius = parseInt(radiusIn.value, 10) || 10;
    writeUrl();
    render();
    if (st.zip || st.near) track('fw_search', { zip: st.zip, radius: st.radius, results: current.length });
  });
  var nearBtn = $('[data-fw-near]');
  if (nearBtn) nearBtn.addEventListener('click', function () {
    if (!navigator.geolocation) { summary.textContent = "Your browser can't share its location; enter a ZIP code instead."; return; }
    nearBtn.disabled = true;
    navigator.geolocation.getCurrentPosition(function (pos) {
      nearBtn.disabled = false;
      st.near = [pos.coords.latitude, pos.coords.longitude];
      st.zip = '';
      zipIn.value = '';
      st.radius = parseInt(radiusIn.value, 10) || 10;
      writeUrl();
      render();
      track('fw_search', { zip: 'near_me', radius: st.radius, results: current.length });
    }, function () {
      nearBtn.disabled = false;
      summary.textContent = "We couldn't get your location; enter a ZIP code instead.";
    }, { timeout: 10000, maximumAge: 600000 });
  });
  $$('[data-city]').forEach(function (b) {
    b.addEventListener('click', function () {
      st.city = b.getAttribute('data-city');
      st.county = '';
      writeUrl();
      render();
    });
  });
  $$('[data-filter]').forEach(function (b) {
    b.addEventListener('click', function () {
      st.filter = b.getAttribute('data-filter');
      writeUrl();
      render();
      track('fw_filter', { filter: st.filter, category: st.category });
    });
  });
  catBar.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-cat]');
    if (!b) return;
    st.category = b.getAttribute('data-cat');
    writeUrl();
    render();
    track('fw_filter', { filter: st.filter, category: st.category });
  });
  moreBtn.addEventListener('click', function () {
    shown += PAGE;
    render({ keepShown: true });
  });
  mapBtn.addEventListener('click', function () {
    var open = mapWrap.hidden;
    mapWrap.hidden = !open;
    mapBtn.setAttribute('aria-pressed', String(open));
    mapBtn.textContent = open ? 'Hide map' : 'Map';
    if (open) {
      track('fw_map_open', {});
      drawMarkers();
      if (map) setTimeout(function () { map.resize(); }, 50);
    }
  });
  if (followZip) followZip.addEventListener('input', syncFollow);
  var ff = document.getElementById('fw-follow-form');
  if (ff) ff.addEventListener('submit', function () {
    syncFollow();
    if (followZip && /^\d{5}$/.test(followZip.value)) saveZip(followZip.value);
    track('fw_follow', { zip: followZip && followZip.value ? followZip.value : st.zip });
  });

  // ------------------------------------------------------------------ start
  readUrl();
  if (st.zip) writeUrl();
  zipIn.value = st.zip;
  radiusIn.value = String(st.radius);
  syncFollow();
  fetch(root.dataset.fwData, { credentials: 'omit' }).then(function (r) {
    if (!r.ok) throw new Error('HTTP ' + r.status);
    return r.json();
  }).then(function (d) {
    data = d || {};
    events = Array.isArray(data.events) ? data.events.filter(function (e) { return e && typeof e === 'object'; }) : [];
    var g = day((data.generated || '').slice(0, 10));
    if (g != null) now = g + DAY / 2;
    buildZipCity();
    countyUi();
    lead();
    render();
  }).catch(function () {
    $$('[data-fw-n],[data-fw-m]').forEach(function (el) { el.textContent = '\u2014'; });
    empty.innerHTML = "The listings couldn't load right now. Please try again in a minute.";
    empty.hidden = false;
  });
})();
